module.exports = __webpack_public_path__ + "img/eductor_parked.c90d3c9d.svg";